import { NavLink, Link } from "react-router-dom";
import { ChevronDown, ExternalLink } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function NavMoreMenu({ label, items, guideHref, guideLabel, employers }) {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger
        data-testid="nav-more-trigger"
        className="inline-flex items-center gap-1 whitespace-nowrap text-[14px] font-medium text-slate-600 hover:text-[#0A1128] data-[state=open]:text-[#0A1128] outline-none transition-colors"
      >
        {label}
        <ChevronDown className="h-3.5 w-3.5 transition-transform duration-200 [[data-state=open]>&]:rotate-180" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" sideOffset={10} data-testid="nav-more-menu" className="min-w-[200px] rounded-xl p-1.5">
        {items.map((item) => (
          <DropdownMenuItem key={item.to} asChild className="rounded-lg px-3 py-2 text-[14px] cursor-pointer">
            <NavLink to={item.to} data-testid={item.testId}>
              {item.label}
            </NavLink>
          </DropdownMenuItem>
        ))}
        <DropdownMenuItem asChild className="rounded-lg px-3 py-2 text-[14px] cursor-pointer">
          <a href={guideHref} target="_blank" rel="noopener noreferrer" data-testid="nav-integration-guide" className="flex items-center justify-between gap-2">
            {guideLabel}
            <ExternalLink className="h-3.5 w-3.5 text-slate-400" strokeWidth={2.2} />
          </a>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild className="rounded-lg px-3 py-2 text-[14px] cursor-pointer">
          <Link to={employers.to} data-testid="nav-for-employers">
            {employers.label}
          </Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
